import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from '@mui/material';
// import createStyles from '@mui/styles/createStyles';
// import makeStyles from '@mui/styles/makeStyles';
import AddIcon from '@mui/icons-material/Add';
import React, { useContext, useState } from 'react';
import { useHistory } from 'react-router-dom';
import ModalContext from '../context/modal';
import UserContext from '../context/user';
import useAccountSetup, { listJoin } from '../hooks/useAccountSetup';
import AddContainerDrawer from './AddContainerDrawer';

type Props = {
  onContainerAdd: () => void;
};
const AddContainer = ({ onContainerAdd }: Props) => {
  const { isLoggedIn } = useContext(UserContext);
  const { setDrawerOpen } = useContext(ModalContext);
  const [containerDrawerOpen, setContainerDrawerOpen] = useState(false);
  const [setupPromptOpen, setSetupPromptOpen] = useState(false);
  const { missing, isTeammate } = useAccountSetup();
  const history = useHistory();

  const handleAddContainer = () => {
    if (!isLoggedIn) {
      setDrawerOpen('login');
      return;
    }
    // The API rejects containers without a company name or a site, so say so
    // now rather than after the form has been filled in.
    if (missing.length > 0) {
      setSetupPromptOpen(true);
      return;
    }
    setContainerDrawerOpen(true);
  };

  // Teammates can't set the company name or add a site, so send the user to
  // the first thing they can actually act on.
  const firstFixable = missing.find((requirement) => !(requirement.ownerOnly && isTeammate));

  const goToSettings = () => {
    setSetupPromptOpen(false);
    history.push(firstFixable?.settingsPath || '/settings');
  };

  const handleContainerDrawerClose = (
    event: {},
    reason: 'backdropClick' | 'escapeKeyDown' | 'closeButtonClick' | 'containersAdded'
  ) => {
    setContainerDrawerOpen(false);
    if (reason === 'containersAdded') {
      onContainerAdd();
    }
  };

  const canFixHere = !!firstFixable;

  return (
    <>
      <Button variant="contained" color="primary" size="large" startIcon={<AddIcon />} onClick={handleAddContainer}>
        Add your container
      </Button>
      <AddContainerDrawer open={containerDrawerOpen} onClose={handleContainerDrawerClose} />

      <Dialog open={setupPromptOpen} onClose={() => setSetupPromptOpen(false)} maxWidth="xs" fullWidth>
        <DialogTitle>Finish setting up your account first</DialogTitle>
        <DialogContent>
          <Typography variant="body2" color="text.secondary" mb={2}>
            {missing.length === 1
              ? 'One thing is missing before you can add containers:'
              : 'A couple of things are missing before you can add containers:'}
          </Typography>
          {missing.map((requirement) => (
            <Box key={requirement.key} mb={1.5}>
              <Typography variant="body2" fontWeight={600}>
                {requirement.title}
              </Typography>
              <Typography variant="body2" color="text.secondary">
                {requirement.missingLabels.length > 0 ? `Still needed: ${listJoin(requirement.missingLabels)}. ` : ''}
                {requirement.why}{' '}
                {requirement.ownerOnly && isTeammate
                  ? `Ask your account owner to add it under ${requirement.settingsLabel}.`
                  : `Add it under ${requirement.settingsLabel}.`}
              </Typography>
            </Box>
          ))}
        </DialogContent>
        <DialogActions>
          <Button color="secondary" onClick={() => setSetupPromptOpen(false)}>
            Close
          </Button>
          {canFixHere ? (
            <Button color="secondary" variant="contained" onClick={goToSettings}>
              Take me there
            </Button>
          ) : null}
        </DialogActions>
      </Dialog>
    </>
  );
};

export default AddContainer;
